import { Component, OnInit } from '@angular/core';
import { MemberService } from '../services/jrni/member.service';
import { Router, RouterModule } from '@angular/router';
import { LoginService } from '../services/jrni/login.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-member-bar',
  templateUrl: './member-bar.component.html',
  styleUrls: ['./member-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
})
export class MemberBarComponent implements OnInit {
  member;
  name;
  currentLink: String;
  intervalId: any;

  constructor(
    private memberService: MemberService,
    private router: Router,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.currentLink = this.router.url;
    this.getMember();
    this.intervalId = setInterval(() => {
      this.getMember();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  getMember() {
    this.currentLink = this.router.url;
    this.memberService.getMember().then((member) => {
      this.member = member;
      if (member) {
        this.name = member.first_name + ' ' + member.last_name;
      }
    });
  }

  logout() {
    this.member = false;
    this.memberService.deleteMember().then((res) => {
      this.loginService.logout();
    });
  }
}